import React from "react";
import { LayoutDashboard, MapPin, MessageCircle, Camera, Activity, Users, DollarSign } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/contexts/AuthContext";

const promotorItems = [
  { icon: MapPin, label: "Execução", path: "/execucao" },
  { icon: DollarSign, label: "Preços", path: "/precos" },
  { icon: LayoutDashboard, label: "Dashboard", path: "/" },
  { icon: MessageCircle, label: "Chat", path: "/chat" },
];

const supervisorItems = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/" },
  { icon: Activity, label: "Monitor", path: "/monitoramento" },
  { icon: MessageCircle, label: "Chat", path: "/chat" },
  { icon: Users, label: "Equipe", path: "/equipe" },
];

const visualizacaoItems = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/" },
  { icon: Activity, label: "Indicadores", path: "/indicadores" },
  { icon: Camera, label: "Evidências", path: "/evidencias" },
  { icon: Users, label: "Desempenho", path: "/desempenho" },
];

const defaultItems = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/" },
  { icon: MapPin, label: "Execução", path: "/execucao" },
  { icon: Activity, label: "Monitor", path: "/monitoramento" },
  { icon: MessageCircle, label: "Chat", path: "/chat" },
];

export const MobileBottomNav = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  function MobileBottomNav(_props, ref) {
    const location = useLocation();
    const navigate = useNavigate();
    const { roles } = useAuth();

    const navItems = roles.includes("promotor")
      ? promotorItems
      : roles.includes("supervisor")
        ? supervisorItems
        : roles.includes("visualizacao")
          ? visualizacaoItems
          : defaultItems;

    return (
      <nav ref={ref} className="fixed bottom-0 left-0 right-0 z-50 border-t bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80 md:hidden safe-bottom">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => {
            const active = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={cn(
                  "flex flex-col items-center justify-center gap-0.5 min-w-[64px] min-h-[44px] px-3 py-1.5 rounded-lg transition-colors touch-manipulation",
                  active
                    ? "text-primary"
                    : "text-muted-foreground hover:text-foreground"
                )}
              >
                <item.icon className={cn("h-5 w-5", active && "text-primary")} />
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    );
  }
);

MobileBottomNav.displayName = "MobileBottomNav";
